import { Component } from '@angular/core';

@Component({
  selector: 'app-visuals',
  imports: [],
  templateUrl: './visuals.html',
  styleUrl: './visuals.scss',
})
export class Visuals {

}
